



import React, { useEffect, useMemo, useState, Suspense, lazy } from 'react';
//import { DeleteBannerImage, DeleteHeaderTypes, GetAllBanner, GetAllHeaderTypes, GetAllLogos, GetAllTenants, deletLogoImages, getAllArea } from '../../../../services/CommonService';
import { Badge, Button, Card, Col, Dropdown, Modal, Table } from "react-bootstrap"
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import Pagination from "react-js-pagination";

import {commonGet, offlineSubscription } from '../../../services/CommonService';
import EventBus from '../../../services/EventBus';
import moment from "moment";



const UserSubscription = ({userprops}) => {
    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };
    const [postModal, setPostModal] = useState(false);
    const svg1 = (
        <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect x="0" y="0" width="24" height="24"></rect>
                <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                <circle fill="#000000" cx="19" cy="12" r="2"></circle>
            </g>
        </svg>
    );
    const [data, setData] = useState([]);
    const [tenantid, setTenantId] = useState(null);
    const [tenantlist, setTenantList] = useState([]);
    const [tenantdata, setTenantData] = useState({});
    const [updateitem, setUpdateItem] = useState({});
    const [activePage, setActivePage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [username, setUserName] = useState(null);
    const [programid,setProgramid] =useState(null);
    const [email, setEmail] = useState(null);
    const [mobilenumber, setMobilenumber] = useState(null);
    useEffect(() => {
        //getBanner();
        getDatalist();
        EventBus.on("loadpagedata", (data) => {
            let obj = {
                payload: {
                    "pageNo": data?.message?.page,
                    "size": 10
                }
            }
            loadData(data?.message?.page);
            //dispatch(fetchAllPaitentsForMedicalBoard({obj:obj}));
        });
        EventBus.remove("loadpagedata");
    }, []);

    const handlePageChange = async (pn) => {
        if (pn !== activePage && !isNaN(pn)) {
            loadNextsetofRecords(pn);
        }
    };
    const loadNextsetofRecords = async (pn) => {
        setActivePage(pn);
        EventBus.dispatch("loadpagedata", {
            message: {
                "page": pn
            }

        });
    };

    const loadData = async (pn) => {

        const reqparams = {
            pageno: pn,
            query: { userid: userprops.id },
            ptype:'USERSUBSCRIPTION'
        }

      
        const respData = await commonGet(reqparams);
        setData(respData.data.docs);
        setTotalRecords(respData.data.totalDocs);
    }

    const getDatalist = async () => {
        let reqparams = null;

        
            reqparams = {
                pageno: '1',
                query: { userid: userprops.id },
                ptype:'USERSUBSCRIPTION'

            }
        
        const respData = await commonGet(reqparams);
        setData(respData.data.docs);
        setTotalRecords(respData.data.totalDocs);

    }

    const subscribeUser =async() =>{

        const reqdata ={
            userid:userprops.id,
            username: userprops.name,
            email: userprops.email,
            mobileno: userprops.username,
            orderid: '',
            paymentid: '',
            paymentmode: 'OFFLINE',
            amount: userprops.tenant.offeramount,
            status: 'COMPLETED',
            gst: '',
            transctiontype: 'Subscription',
            description: 'Platform purchase',
            tenantid:userprops.tenant.id,
            tenant:userprops.tenant
        }

        const RespdData = await offlineSubscription(reqdata);

        if(RespdData.data.id){
        notifyTopFullWidth("Platform subscription successful");
        getDatalist();
        }else{
            notifyTopFullWidth(RespdData.message);
        }

    }

   






    return (<>
        <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
        />

        <Col lg={12}>
            <Card>
                <Card.Header>

                    <Card.Title>User Subscriptions<Button onClick={() => subscribeUser()}
                            className="me-2" variant="primary btn-square"
                            title="Subscribe"
                        >
                            
                            Subscribe
                        </Button>


                    </Card.Title>
                    
                  

                </Card.Header>
                <Card.Body>
                    <Table responsive>
                        <thead>
                            <tr>

                                <th>
                                    <strong>Start Date</strong>
                                </th>
                                



                                <th>End Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map(item => (
                                <tr>
                                    <td>
                                        {moment(item.startdate).format('YYYY-MM-DD h:mm:ss a')}
                                    </td>
                        
                                    
                                    <td>
                                    {moment(item.enddate).format('YYYY-MM-DD h:mm:ss a')}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                    <div >

                        <Pagination
                            activePage={activePage}
                            itemsCountPerPage={10}
                            totalItemsCount={totalRecords}
                            pageRangeDisplayed={5}
                            onChange={handlePageChange}
                            activeClass="active"
                            itemClass="page-item"
                            innerClass="pagination mb-0"
                            linkClass="page-link"
                            firstPageText="First"
                            lastPageText="Last"
                            prevPageText="Previous"
                            nextPageText="Next"
                            disabledClass="disabled"
                            activeLinkClass="disabled"
                        />
                    </div>
                </Card.Body>
            </Card>
        </Col>

        

    </>)
}
export default UserSubscription;